import { apiClient, apiV2Client } from '@/services/api-client'
import type {
  LoginRequest,
  LoginV2Response,
  LogoutRequest,
  MeProfile,
  MfaSetupData,
  RefreshRequest,
  TokenResponse,
} from '@/features/auth/types/auth.types'
import type { ApiAccessLevels } from '@/features/users/types/user.types'

export const authService = {
  login: (data: LoginRequest) => apiClient.post<TokenResponse>('/auth/login', data),

  loginV2: (data: LoginRequest) => apiV2Client.post<LoginV2Response>('/auth/login', data),

  getMfaSetup: (mfaToken: string) =>
    apiV2Client.get<MfaSetupData>('/auth/mfa/setup', { token: mfaToken }),

  verifyMfaSetup: (code: string, mfaToken: string) =>
    apiV2Client.post<TokenResponse>('/auth/mfa/setup/verify', { code }, { token: mfaToken }),

  validateMfa: (code: string, mfaToken: string) =>
    apiV2Client.post<TokenResponse>('/auth/mfa/validate', { code }, { token: mfaToken }),

  refresh: (data: RefreshRequest) => apiClient.post<TokenResponse>('/auth/refresh', data),

  logout: (data: LogoutRequest, token: string) =>
    apiClient.post<void>('/auth/logout', data, { token }),

  me: (token: string) => apiClient.get<MeProfile>('/auth/me', { token }),

  myAccessLevels: (token: string) =>
    apiClient.get<ApiAccessLevels>('/auth/me/access-levels', { token }),

  changeUserPassword: (currentPassword: string, newPassword: string, token: string) =>
    apiClient.patch<void>('/auth/me/password', { currentPassword, newPassword }, { token }),
}
